<template>
  <base-dialog show-close :visible.sync="visible">
    <template v-slot:header>发布应用</template>
    <el-form class="form" label-position="left" label-width="88px">
      <el-form-item label="版本号">
        <el-input disabled :value="app.templateInfo.version"></el-input>
      </el-form-item>
      <el-form-item>
        <template slot="label">
          更新内容
          <span style="color:red">*</span>
        </template>
        <el-input type="textarea" :rows="4" v-model="versionDesc"></el-input>
      </el-form-item>
    </el-form>
    <template v-slot:footer>
      <base-button @click="visible = false">取消</base-button>
      <base-button type="primary" @click="publishApp">确定</base-button>
    </template>
  </base-dialog>
</template>
<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import * as appApi from "@/api/userCenter/app"
import { deepClone } from "@/utils/common"
import { getAppTemplateVersionList } from "@/api/userCenter/app"
import { loadingService } from "@/utils/ui"
export default {
  name: "publish-template-dialog",
  components: { BaseDialog, BaseButton },
  data() {
    return {
      visible: false,
      versionDesc: "",
      app: {
        templateInfo: {
          version: ""
        }
      }
    }
  },
  methods: {
    init(app) {
      this.app = deepClone(app)
      getAppTemplateVersionList(app.id).then(versionList => {
        this.versionDesc = versionList[versionList.length - 1]?.desc || ""
      })
      this.visible = true
    },
    publishApp() {
      if (!this.versionDesc) {
        this.$message.error("请填写更新内容")
        return
      }
      let loadingInstance = loadingService({ text: "请求中" })
      appApi
        .publishAppTemplateVersion(this.versionDesc, this.app.id)
        .then(() => {
          this.$message.success("模板已发布")
          this.$emit("refresh")
          this.visible = false
        })
        .finally(() => loadingInstance.close())
    }
  }
}
</script>
